import { documentDTO } from './data-model.document';

/**
 * Plain-TS synchronous document state container with observer notification.
 *
 * Deliberately has no RxJS or Angular dependency so it can be used in both
 * the Chrome extension content script (plain TS) and the Angular side panel /
 * web app (wrapped by DocumentStateService with an RxJS layer on top).
 */
export class DocumentStore {
  private _doc: documentDTO;
  private _listeners: Array<(doc: documentDTO) => void> = [];

  constructor(initial: documentDTO) {
    this._doc = initial;
  }

  /** Return the current document state. */
  get(): documentDTO {
    return this._doc;
  }

  /** Replace the document state and notify all subscribers. */
  update(doc: documentDTO): void {
    this._doc = doc;
    for (const fn of this._listeners) {
      fn(doc);
    }
  }

  /**
   * Subscribe to document state changes.
   * Returns an unsubscribe function — call it to stop receiving notifications.
   */
  subscribe(fn: (doc: documentDTO) => void): () => void {
    this._listeners.push(fn);
    return () => {
      this._listeners = this._listeners.filter((l) => l !== fn);
    };
  }
}
